import { SET_GEOFENCE_CONTAINER_SHOW, TOGGLE_GEOFENCE_CONTAINER_SHOW } from './fencesContainerUI-actions';

export interface IFencesContainerUIState {
    isGeoFenceContainerVisible: boolean;
}

const initialState: IFencesContainerUIState = {
    isGeoFenceContainerVisible: false,
};

export const fencesContainerUIReducer = (
    state = initialState,
    action: any
): IFencesContainerUIState => {
    switch (action.type) {
        case SET_GEOFENCE_CONTAINER_SHOW:
            return { ...state, isGeoFenceContainerVisible: action.show };
        case TOGGLE_GEOFENCE_CONTAINER_SHOW:
            return { ...state, isGeoFenceContainerVisible: !state.isGeoFenceContainerVisible };
        default:
            return state;
    }
};
